export default __webpack_public_path__ + "static/media/hdb-flats.f025d082.svg";